import { FeatureFlag } from '../featureFlags.generated';
import { useSplitFlag } from './useSplitFlag';

/**
 * NOTE: uses Suspense, make sure to handle it accordingly
 */
export function useFeatureFlagEnabled(flagName: FeatureFlag): boolean {
  return useSplitFlag(flagName, (flag) => flag === 'on');
}
